import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import "./Assests/Css/theme.css";
import "./Assests/Css/maicons.css";
import Loader from "./Components/User/Loader";
import Terms from "./Components/User/Terms";

// lazy loader
const LazyIndex = lazy(() => import("./Pages"));

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        {/* adding loader */}
        <Suspense fallback={<Loader />}>
          <Routes>
            {/* Your main index (home + nested routes are handled inside LazyIndex) */}
            <Route path="/*" element={<LazyIndex />} />

            {/* Terms & Conditions page */}
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </Suspense>
      </div>
    </HelmetProvider>
  );
}

export default App;
